import React, { memo } from "react";

import BaseNode from "../Base/Base";
import EmbeddedVideoCard from "../../../../../../../components/cards/flowDesignerDropCard/EmbeddedVideoCard/EmbeddedVideoCard";
import type AssetTypes from "../../../../../../../enums/assetTypes";
import { type FlowItemEmbeddedVideo } from "../../../types";
import { type FlowItemBase } from "../types";

interface IEmbeddedVideoNodeOwnProps {
  type: AssetTypes.EmbeddedVideo;
  data: FlowItemEmbeddedVideo & FlowItemBase;
}

const EmbeddedVideoNode: React.FC<IEmbeddedVideoNodeOwnProps> = ({ type, data }) => {
  return (
    <BaseNode data={data}>
      <EmbeddedVideoCard item={{ ...data, elementType: type }} />
    </BaseNode>
  );
};

export default memo(EmbeddedVideoNode);
